module.exports = __webpack_public_path__ + "img/checkmark.d19417bb.svg";